<template>
    <div class="main_center" style="margin: 0 0;padding-top: 8px;">
        <div class="content" style="padding: 16px 16px 5px 16px;">
            <el-form ref="form" :model="form" label-width="100px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="状态：">
                            <el-select v-model="form.filter.status" placeholder="请选择状态" @change="searchBtn">
                                <el-option
                                    v-for="item in statusOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="关键字：" props="searchKey">
                            <el-input v-model="form.searchKey" clearable
                                      placeholder="请输入项目名称、招标（采购）人、中标单位进行搜索"
                                      @keyup.enter.native="searchBtn"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="">
                            <div>
                                <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
                                <el-button size="small" type="primary" @click="searchBtn">搜索</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <space :left="-16" :right="-16" :bottom="16"/>

            <div style="margin-bottom: 12px">
                <el-button v-if="hasBtnPermission('singleWindowService.deal.add')"
                           type="primary" size="small" @click="onClickAdd"
                >新增</el-button>
                <el-button v-if="hasBtnPermission('singleWindowService.deal.delete')"
                           size="small" @click="onClickMultiDelete"
                >删除</el-button>
            </div>
            <el-table :data="tableData"
                      v-loading="dataListLoading"
                      ref="expertExtractTable"
                      :height="tableMaxHeight"
                      stripe border
                      @selection-change="handleSelectionChange"
            >
                <el-table-column
                    fixed
                    label="序号"
                    type="index"
                    :index="indexMethod"
                    width="50"
                    align="center"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    fixed
                    type="selection"
                    align="center"
                    width="55"
                    :selectable="isSelectable"
                ></el-table-column>
                <el-table-column label="状态" prop="status" align="left" width="150">
                    <template slot-scope="scope">
                        <span>{{scope.row.status | statusFilter}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="项目名称" prop="projectName" align="left" min-width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="招标（采购）人" prop="tendererName" align="left"
                                 width="150px" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="中标单位" prop="winningCompany" align="left" width="150px"></el-table-column>
                <el-table-column label="中标金额" prop="winningAmount" align="left" width="150px"></el-table-column>
                <el-table-column label="创建时间" prop="createDate" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="修改时间" prop="updateDate" align="left" width="200"
                                 :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="操作" align="left" width="150px" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" title="查看" @click="onClickGoToView(scope.row)">
                            查看
                        </el-button>
                        <el-button v-if="scope.row.status === 1 && hasBtnPermission('singleWindowService.deal.delete')"
                                   type="text" size="small" @click="onClickDeleteRow(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange"
            >
            </pagination>
        </div>
    </div>
</template>

<script>
import space from "@/views/common/components/space.vue";
import Pagination from "@/components/Pagination";

export default {
    name: "projectList",
    components: {
        space,
        Pagination,
    },
    data() {
        return {
            form: {
                searchKey: "",
                filter: {
                    status: '',
                },
            },
            businessType: "GC",
            moreSearchItem: false,
            tableData: [],
            pageIndex: 1,
            pageSize: 12,
            total: 0,
            dataListLoading: false,
            tableMaxHeight: document.documentElement.clientHeight - 390,
            sortParams: {
                prop: '',
                order: ''
            },
            businessTypeNamelist: [], // 业务类型选择列表
            multipleSelection: [],
            statusOptions: [
                {
                    label: '全部',
                    value: ''
                },
                {
                    label: '未提交',
                    value: 1
                },
                {
                    label: '已提交',
                    value: 2
                },
            ]
        };
    },
    filters: {
        statusFilter(status) {
            //1-未提交 2-已提交
            switch (status) {
                case 1:
                    return '未提交';
                case 2:
                    return '已提交';
                default:
                    return '';
            }
        },
        undertakeDeptFilter(status) {
            //1 工程建设部 2 政府采购部 3 资源与产权交易部
            switch (status) {
                case 1:
                    return '工程建设部';
                case 2:
                    return '政府采购部';
                case 3:
                    return '资源与产权交易部';
                default:
                    return '';
            }
        },
    },
    activated() {
        this.getListData();
    },
    mounted() {
        this.ifmove();
        let resizeTag = true;
        let that = this;
        window.onresize = () => {
            if (resizeTag) {
                //防抖动
                that.ifmove();
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 1000);
            }
        };
    },
    methods: {
        //获取列表数据
        getListData() {
            this.$http.post(`/bidResultSummary/list`, {
                page: this.pageIndex,
                rows: this.pageSize,
                searchKey: this.form.searchKey,
                filter: this.form.filter,
            }).then((res) => {
                this.tableData = res.data.rows;
                this.total = res.data.total;
            });
        },
        //分页
        paginationChange({page, limit}) {
            this.pageIndex = page;
            this.pageSize = limit;
            this.getListData();
        },
        //序号
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        // 判断行是否可选择
        isSelectable(row) {
            return row.status === 1;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        ifmove() {
            let tableMaxHeight = document.documentElement.clientHeight - 390;
            this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight;
            });
        },
        //搜索
        searchBtn() {
            this.pageIndex = 1;
            this.getListData();
        },
        //重置
        reflash() {
            this.form = {
                searchKey: "",
                filter: {
                    status: '',
                },
            };
            this.pageIndex = 1;
            this.getListData();
        },
        //新增
        onClickAdd() {
            this.$router.push({
                name: "singleWindowServiceDealAdd",
            });
        },
        //查看
        onClickGoToView(row) {
            if (row.status === 1) { //进到新增页面
                this.$router.push({
                    name: "singleWindowServiceDealAdd",
                    query: {
                        id: row.id,
                    }
                });
            }else { //进到查看页面
                this.$router.push({
                    name: "singleWindowServiceDealDetail",
                    query: {
                        id: row.id,
                    }
                });
            }
        },
        //删除
        onClickDeleteRow(row) {
            this.$confirm('确认删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post(`/bidResultSummary/batchDelete`, [row.id]).then(({data}) => {
                    if (data.code === '1') {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getListData();
                    }else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        //批量删除
        onClickMultiDelete() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: '请选择要删除的项目',
                    type: 'warning'
                });
                return;
            }
            this.$confirm(`确认删除选中的${this.multipleSelection.length}个项目吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const bidResultSummaryIds = this.multipleSelection.map(item => item.id)
                this.$http.post(`/bidResultSummary/batchDelete`, bidResultSummaryIds).then(({data}) => {
                    if (data.code === '1') {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getListData();
                        this.multipleSelection = [];
                    }else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    },
};
</script>


<style lang="less" scoped>
::v-deep .main_center .content {
    padding: 10px 10px 0 10px !important;
}
</style>
